import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { CurrentPortfolio } from 'src/app/models/current-portfolio.model';
import { User } from 'src/app/models/user.model';
import { AuthService } from 'src/app/services/auth.service';
import { CurrentBenchmark } from 'src/app/models/current-benchmark.model';
import { ClustersService } from 'src/app/services/clusters.service';
import { Cluster } from 'src/app/models/cluster.model';

@Component({
  selector: 'app-analytics',
  templateUrl: './analytics.component.html',
  styleUrls: ['./analytics.component.scss']
})
export class AnalyticsComponent implements OnInit, OnDestroy {

  user: User;
  userSubscription: Subscription;

  currentCluster: Cluster;
  currentClusterSubscription: Subscription;
  currentPortfolio: CurrentPortfolio;
  currentPortfolioSubscription: Subscription;
  currentOriginal: CurrentPortfolio;
  currentOriginalSubscription: Subscription;
  currentBenchmark: CurrentBenchmark;
  currentBenchmarkSubscription: Subscription;
  currentInvestable: CurrentPortfolio;
  currentInvestableSubscription: Subscription;
  currentProtected: CurrentPortfolio;
  currentProtectedSubscription: Subscription;

  selectBlock: string = '';

  panelOpenState = false;

  styleBoxData: any;

  constructor(private authService: AuthService,
              private clustersService: ClustersService) {}

  ngOnInit(): void {
    this.userSubscription = this.authService.userSubject.subscribe(
      (user: User) => {
        this.user = user;
      }
    );
    this.authService.emitUser();

    this.subscribeToCurrentCluster();
    this.subscribeToCurrentPortfolio();
    this.subscribeToCurrentOriginal();
    this.subscribeToCurrentInvestable();
    this.subscribeToCurrentProtected();
    this.subscribeToCurrentBenchmark();
  }

  ngOnDestroy() {
    if(this.userSubscription!=undefined) { this.userSubscription.unsubscribe(); }
    if(this.currentClusterSubscription!=undefined) { this.currentClusterSubscription.unsubscribe(); }
    if(this.currentPortfolioSubscription!=undefined) { this.currentPortfolioSubscription.unsubscribe(); }
    if(this.currentOriginalSubscription!=undefined) { this.currentOriginalSubscription.unsubscribe(); }
    if(this.currentInvestableSubscription!=undefined) { this.currentInvestableSubscription.unsubscribe(); }
    if(this.currentProtectedSubscription!=undefined) { this.currentProtectedSubscription.unsubscribe(); }
    if(this.currentBenchmarkSubscription!=undefined) { this.currentBenchmarkSubscription.unsubscribe(); }
  }

  subscribeToCurrentCluster() {
    this.currentClusterSubscription = this.clustersService.currentClusterSubject.subscribe(
      (cluster: Cluster) => {
        this.currentCluster = cluster;
      }
    );
    this.clustersService.emitCurrentCluster();
  }

  subscribeToCurrentPortfolio() {
    this.currentPortfolioSubscription = this.clustersService.currentPortfolioSubject.subscribe(
      (portfolio: CurrentPortfolio) => {
        this.currentPortfolio = portfolio;
      }
    );
    this.clustersService.emitCurrentPortfolio();
  }

  subscribeToCurrentOriginal() {
    this.currentOriginalSubscription = this.clustersService.currentOriginalSubject.subscribe(
      (original_portfolio: CurrentPortfolio) => {
        this.currentOriginal = original_portfolio;
        this.computeStyleBoxData();
      }
    );
    this.clustersService.emitCurrentOriginal();
  }

  subscribeToCurrentInvestable() {
    this.currentInvestableSubscription = this.clustersService.currentInvestableSubject.subscribe(
      (investable_portfolio: CurrentPortfolio) => {
        this.currentInvestable = investable_portfolio;
        this.computeStyleBoxData();
      }
    );
    this.clustersService.emitCurrentInvestable();
  }

  subscribeToCurrentProtected() {
    this.currentProtectedSubscription = this.clustersService.currentProtectedSubject.subscribe(
      (protected_portfolio: CurrentPortfolio) => {
        this.currentProtected = protected_portfolio;
        this.computeStyleBoxData();
      }
    );
    this.clustersService.emitCurrentProtected();
  }

  subscribeToCurrentBenchmark() {
    this.currentBenchmarkSubscription = this.clustersService.currentBenchmarkSubject.subscribe(
      (benchmark: CurrentBenchmark) => {
        this.currentBenchmark = benchmark;
      }
    );
    this.clustersService.emitCurrentBenchmark();
  }

  computeRankings(portfolio: CurrentPortfolio) {
    if (!portfolio) {return undefined;}
    return {
      factor_deconcentration: {
        nb_analysis: portfolio.factorAnalysis.rankings.factor_deconcentration_quality.nb_analysis_factor_deconcentration_quality,
        rank: portfolio.factorAnalysis.rankings.factor_deconcentration_quality.rank_factor_deconcentration_quality,
        rating: portfolio.factorAnalysis.diversification.factor_deconcentration_quality_rating
      },
      factor_diversification: {
        nb_analysis: portfolio.factorAnalysis.rankings.factor_diversification_quality.nb_analysis_factor_diversification_quality,
        rank: portfolio.factorAnalysis.rankings.factor_diversification_quality.rank_factor_diversification_quality,
        rating: portfolio.factorAnalysis.diversification.factor_diversification_quality_rating
      }
    }
  }

  computeStyleBoxData() {
    this.styleBoxData = {
      original:   this.computeRankings(this.currentOriginal),
      investable: this.computeRankings(this.currentInvestable),
      protected:  this.computeRankings(this.currentProtected)
    }
  }

}
